import { useAppSelector } from '@/Application/Hooks/Redux';
import { Title } from '@/modules/perseo-billing/components/title/Title';
import {
  AppliedInvoice,
  NeedInvoice
} from '@/modules/perseo-billing/containers';

const titleLabel = 'Elige el medio de pago';
const howToPayLabel = '¿Cómo vas a pagar hoy?';

interface TitleAndInvoiceProps {
  isForeignDocument: boolean;
}

export const TitleAndInvoice = ({
  isForeignDocument
}: TitleAndInvoiceProps) => {
  const { data: cart } = useAppSelector((state) => state.cart);

  const hasInvoice = cart?.billingAddress?.isInvoice;
  const invoiceLabel = hasInvoice ? titleLabel : howToPayLabel;

  return (
    <>
      <Title
        title={invoiceLabel}
        subcomponent={
          !isForeignDocument ? (
            <NeedInvoice isForeignDocument={isForeignDocument} />
          ) : undefined
        }
        isHeader
      />
      {hasInvoice && <AppliedInvoice border />}
    </>
  );
};
